// extracted by mini-css-extract-plugin
export default {"mobileOverlayDialog":"xvcGs5","fixedWidth":"KWy3rN"};